<template>
    <div class="simple-sidebar sm-sidebar" :class="open ? 'd-block' : 'd-none d-lg-block'" id="filter_search">
        <div class="search-sidebar_header">
            <h4 class="ssh_heading">Close Filter</h4>
            <button @click="toggle" class="w3-bar-item w3-button w3-large"><i class="fa-regular fa-circle-xmark fs-5 text-muted-2"></i></button>
        </div>
        <div class="sidebar-widgets">
            <div class="dashboard-navbar">
                <div class="d-user-avater">
                    <img :src="userData?.service_provider_details.profile_image" class="img-fluid avater" alt="">
                    <h4>{{ userData?.service_provider_details.name }}</h4>
                    <h6>{{ categoryName || 'Unknown Category' }}</h6>
                    <span>{{ stateName || 'Unknown State' }}</span>
                    <!-- <span>{{ categoryName || 'Unknown Category' }}</span> -->
                </div>
                <div class="d-navigation">
                    <ul>
                        <!-- <li :class="current === '/dashboard' ? 'active' : ''"><router-link to="/dashboard"><i class="fa-solid fa-gauge"></i>Dashboard</router-link></li>
                        
                        <li :class="current === '/bookmark-list' ? 'active' : ''"><router-link to="/bookmark-list"><i class="fa-solid fa-bookmark"></i>Bookmarked Listings</router-link></li>
                        <li :class="current === '/my-property' ? 'active' : ''"><router-link to="/my-property"><i class="fa-solid fa-building-circle-check"></i>My Properties</router-link></li>
                        <li :class="current === '/submit-property-dashboard' ? 'active' : ''"><router-link to="/submit-property-dashboard"><i class="fa-solid fa-house"></i>Submit New Property</router-link></li>
                        <li :class="current === '/change-password' ? 'active' : ''"><router-link to="/change-password"><i class="fa-solid fa-unlock"></i>Change Password</router-link></li> -->
                        <li :class="route.path === `/dashboard/${userData?.service_provider_details.id}` ? 'active' : ''">
                            <router-link :to="`/dashboard/${userData?.service_provider_details.id}`">
                                <i class="fa-solid fa-address-card"></i>
                                {{ $t('My Profile') }}
                            </router-link>
                        </li>
                        <li :class="route.path === '/my-branches' ? 'active' : ''"><router-link to="/my-branches"><i class="fa-solid fa-building px-2"></i>{{$t('Branches')}}</router-link></li>
                        <li>
                            <a href="#" data-bs-toggle="modal" data-bs-target="#deleteAccountModal">
                                <i class="fa-solid fa-user-xmark px-2"></i>
                                {{$t('Delete Account')}}
                            </a>
                        </li>
                        <li><a href="#" @click.prevent="logout"><i class="fa-solid fa-power-off"></i>{{$t('Log Out')}}</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="deleteAccountModal" tabindex="-1" aria-labelledby="deleteAccountModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="deleteAccountModalLabel">{{$t('Confirm Delete')}}</h5>
            <button type="button" class="btn-close ms-3" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
            {{$t('Are you sure you want to delete your account?')}}
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{$t('Cancel')}}</button>
            <button type="button" class="btn btn-danger" @click="confirmDelete">{{$t('Yes, Delete')}}</button>
        </div>
        </div>
    </div>
    </div>
</template>

<script setup>
import {  defineProps, defineEmits } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';
defineProps({
    open: Boolean,
    userData: Object,
    categoryName: String,
    stateName: String,
});

const emit = defineEmits(['update:open']);
const route = useRouter();
const toggle = () => {
    emit('update:open', !open);
};
    
    
const logout = async () => {
    try {
        const token = localStorage.getItem('auth_token')
            console.log("token22",token);               
        await axios.post(
        '/logout',
        null,
        {
            headers: {
            Authorization: `Bearer ${token}`,
            },
        }
        );

        localStorage.removeItem('auth_token');
        localStorage.removeItem('user_type');
        route.push('/login-page');
    } catch (error) {
        console.error('Logout failed:', error);
    }
};
const confirmDelete = async () => {
    try {
        const token = localStorage.getItem('auth_token');
        
        await axios.get('/delete-account', {
        headers: { Authorization: `Bearer ${token}` },
        });
        await axios.post('/logout', null, { headers: { Authorization: `Bearer ${token}` } });
        
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user_type');
        route.push('/login-page').then(() => {
            location.reload();
        });
    } catch (error) {
        console.error('Delete account failed:', error);
    }
};
</script>
